import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { get } from 'lodash';
import { menuToggler } from '@bd/bdcore-utilities';
import { Link } from '@bd/bdcore-named-routes';

function ToggleNavAreaLinks({
  areas, isActiveMenu, activateMenu,
  className, submetroMenu, productMenu }) {
  return (
    <ul className={`${className}`}>
      {
        areas.filter(area => area.isMetro).map(metro => (
          <li className="ToggleNav_subMenuItem" key={metro.name}>
            <Link
              name="communities"
              params={{
                communityMarketAreaMetro: get(metro, 'name'),
              }}
              className="ToggleNav_subSubMenuHeading"
              role="button"
              tabIndex="0"
              onClick={activateMenu(metro.name)}
            >
              {metro.name}
            </Link>
            {
              submetroMenu &&
              <ul className={`${isActiveMenu(metro.name) ? 'ToggleNav_subMenu-active' : ''} ToggleNav_subMenu`}>
                {
                  areas.filter(area => area.parentMetro === metro.name).map(submetro => (
                    <li key={submetro.name}>
                      <Link
                        name="communities"
                        params={{
                          communityMarketAreaMetro: get(metro, 'name'),
                          communityMarketAreaSubMetro: get(submetro, 'name'),
                        }}
                      >
                        {submetro.name}
                      </Link>
                    </li>
                  ))
                }
              </ul>
            }
            {
              productMenu &&
              <ul className={`${isActiveMenu('metro-product') ? 'ToggleNav_subMenu-active' : ''} ToggleNav_subMenu`}>
                <li className="ToggleNav_subMenuItem"><Link name="communities" params={{ communityMarketAreaMetro: get(metro, 'name') }}>Communities</Link></li>
                <li className="ToggleNav_subMenuItem"><Link name="homes" params={{ communityMarketAreaMetro: get(metro, 'name') }}>Quick Move-In Homes</Link></li>
                <li className="ToggleNav_subMenuItem"><Link name="plans" params={{ communityMarketAreaMetro: get(metro, 'name') }}>Available Plans</Link></li>
                <li className="ToggleNav_subMenuItem"><Link name="model-homes" params={{ communityMarketAreaMetro: get(metro, 'name') }}>Model Homes</Link></li>
                <li className="ToggleNav_subMenuItem"><Link name="open-houses" params={{ communityMarketAreaMetro: get(metro, 'name') }}>Open Houses</Link></li>
                <li className="ToggleNav_subMenuItem"><Link name="build-on-your-lot">Build On Your Lot</Link></li>
                <li className="ToggleNav_subMenuItem"><Link name="special-offers">Special Offers</Link></li>
              </ul>
            }
          </li>
        ))
      }
    </ul>
  );
}

ToggleNavAreaLinks.propTypes = {
  areas: PropTypes.arrayOf(PropTypes.object).isRequired,
  isActiveMenu: PropTypes.func.isRequired,
  activateMenu: PropTypes.func.isRequired,
  className: PropTypes.string.isRequired,
  submetroMenu: PropTypes.bool,
  productMenu: PropTypes.bool,
};

ToggleNavAreaLinks.defaultProps = {
  submetroMenu: false,
  productMenu: false,
};

export default withData(
  {
    areas: true,
  },
)(menuToggler((ToggleNavAreaLinks)));



// WEBPACK FOOTER //
// ./src/components/Header/ToggleNavAreaLinks.js